var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7498 19.7109V29.7109C33.7498 30.1249 33.4138 30.4609 32.9998 30.4609C32.5858 30.4609 32.2498 30.1249 32.2498 29.7109V21.522L20.5298 33.2419C20.3838 33.3879 20.1918 33.4619 19.9998 33.4619C19.8078 33.4619 19.6158 33.3889 19.4698 33.2419C19.1768 32.9489 19.1768 32.4739 19.4698 32.1809L31.1897 20.4609H22.9998C22.5858 20.4609 22.2498 20.1249 22.2498 19.7109C22.2498 19.2969 22.5858 18.9609 22.9998 18.9609H32.9998C33.0978 18.9609 33.1949 18.981 33.2869 19.019C33.4699 19.095 33.6159 19.241 33.6929 19.425C33.7299 19.516 33.7498 19.6129 33.7498 19.7109Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUp);
export default __webpack_public_path__ + "static/media/arrow_right_up.abc7139cab4b6c9b39a38594b2f0c411.svg";
export { ForwardRef as ReactComponent };